import React from "react";
import { useHistory } from "react-router-dom";
import { Merchandise } from "types";
import { SecondaryButton } from "@/components/Common/SecondaryButton";
import { ContentLayout } from "@/components/Layout/ContentLayout";
import { ProductPhotoList } from "@/components/Product/ProductPhotoList";

export const MerchandisePhotoList = ({ merchandise }: { merchandise?: Merchandise }) => {
    const history = useHistory();

    const handleCancel = () => {
        history.push(`/products/merchandise`);
    };

    if (!merchandise) return null;

    return (
        <ContentLayout isWide>
            <ContentLayout.Section
                title="Photos"
                description="You can add a maximum of 10 .jpg, .png and .webp images to each product with a maximum size of 5 MB. Suggested pixel dimensions 1024x768"
                tooltip="Uploaded photos will be visible to customers using online checkout."
            >
                <ProductPhotoList product={merchandise} />
            </ContentLayout.Section>

            <ContentLayout.Footer preferenceSidebar>
                <SecondaryButton type="reset" onClick={handleCancel}>
                    Cancel
                </SecondaryButton>
            </ContentLayout.Footer>
        </ContentLayout>
    );
};
